import { useState, useCallback, useContext } from "react";
import { generateRequestId } from "../utils/RequestIdGenerator";
import {  axiosInstanceV2 } from "../services/AxiosIntercepter";
import { ApiType } from "../services/ApiTags";
import { AuthContext } from "../context/AuthContext";
import { LOGIN_ID, SESSION_ID, USER_NAME } from "../constants/LocalStorageKeyValuePairString";
import { getFromLocalStorage } from "../utils/localStorageUtils";

const useAxiosHookV2 = () => {
  const [data, setData] = useState(null);
  const [apiCallError, setApiCallError] = useState(null);
  const [showProgressBar, setProgressBar] = useState(false);
  const { authDetails } = useContext(AuthContext);

  const fetchData = useCallback(
    async (
      url,
      apiType,
      method = ApiType.POST_METHOD,
      encryptedData = null,
      options = {},
      callback
    ) => {
      // show progress bar
      setProgressBar(true);

      let requestData = {};
        // set common request content
        requestData = {
          requestId: generateRequestId(),
          loginId:getFromLocalStorage(LOGIN_ID),
          sessionId:getFromLocalStorage(SESSION_ID),
          contentData: encryptedData,
          loginUserName:getFromLocalStorage(USER_NAME)
        };
      try {
        const response = await axiosInstanceV2({
          url,
          method,
          data: requestData,
          ...options,
        });
        setData(response.data);
        if (callback) {
          callback(response.data);
        }
      } catch (error) {
        // show error
        setApiCallError(error);
      } finally {
        // hide progress bar
        setProgressBar(false);
      }
    },
    []
  );

  return { data, apiCallError, showProgressBar, fetchData };
};

export default useAxiosHookV2;
